<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [user]="qna.author"
            [mode]="'avatar'"
          ></ngx-view-user-display>
        </div>

        <div>
          <ngx-view-user-display
            [user]="qna.author"
            [mode]="'name'"
          ></ngx-view-user-display>
          <ngx-view-time-ago [currentDate]="qna.createdOn"></ngx-view-time-ago>

          <div *ngIf="qna.refTitle" class="text-link">
            <nb-icon icon="globe-outline"></nb-icon>
            <a class="link" (click)="navigateRef(qna)">
              {{
                qna.refTitle.length < 60
                  ? qna.refTitle
                  : qna.refTitle.substring(0, 60) + "..."
              }}
            </a>
          </div>
          <div *ngIf="!qna.refTitle || mode == 'detail'" class="text-link">
            <nb-icon icon="hash-outline"></nb-icon>
            <ngx-view-tags
              [tags]="qna.tags"
              (onTagSelected)="tagSelected($event)"
            ></ngx-view-tags>
          </div>

          <div>
            <button
              nbButton
              ghost
              size="tiny"
              [status]="
                qna.status == 1
                  ? 'success'
                  : qna.status == -1
                  ? 'warning'
                  : 'info'
              "
              (click)="replyQnA()"
            >
              <nb-icon
                [icon]="qna.status == 1 ? 'eye-outline' : 'eye-off-outline'"
              ></nb-icon>
              <span>{{
                qna.status == 1
                  ? "Đã giải đáp"
                  : qna.status == -1
                  ? "Khóa trả lời"
                  : "Tìm câu trả lời"
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <ngx-button-bookmark *ngIf="mode == 'detail'" [qna]="qna">
      </ngx-button-bookmark>

      <button
        nbButton
        ghost
        shape="round"
        status="primary"
        size="small"
        class="action-button"
        [disabled]="loading"
        [class.btn-pulse]="loading"
        [nbContextMenu]="menuItems"
        [nbContextMenuTag]="'action-buttons-' + qna.id"
        (click)="loadButtonAction(qna)"
      >
        <nb-icon icon="more-horizontal-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body *ngIf="mode != 'detail'">
    <h6 class="text-heading" (click)="loadContent(true)">{{ qna.title }}</h6>
    <div class="text-hint">{{ qna.description }}</div>

    <a *ngIf="qna.content && !isMore" (click)="loadContent(true)" class="link">
      <nb-icon icon="chevron-down-outline"></nb-icon>
      Xem thêm
    </a>

    <nb-card *ngIf="qna.sourceType && isMore">
      <nb-card-body
        *ngIf="qna.sourceType == 'images' && qna.imagesUrl.length > 0"
      >
        <ngx-view-gallery [imagesUrl]="qna.imagesUrl"> </ngx-view-gallery>
      </nb-card-body>

      <nb-card-body *ngIf="qna.sourceType == 'video' && qna.videoUrl != ''">
        <ngx-view-video [url]="qna.videoUrl"></ngx-view-video>
      </nb-card-body>

      <nb-card-body *ngIf="qna.sourceType == 'document' && qna.content != ''">
        <ngx-view-document [content]="qna.content"> </ngx-view-document>
      </nb-card-body>
    </nb-card>

    <a *ngIf="qna.content && isMore" (click)="loadContent(false)" class="link">
      <nb-icon icon="chevron-up-outline"></nb-icon>
      Thu gọn
    </a>
  </nb-card-body>

  <nb-card-footer>
    <div class="button-actions">
      <ngx-view-like *ngIf="mode == 'detail'" [qna]="qna"> </ngx-view-like>
      <button
        *ngIf="mode != 'detail'"
        nbButton
        ghost
        shape="semi-round"
        size="small"
      >
        <i class="fas fa-thumbs-up"></i>
        <span>{{ qna.noLiked | number }} </span>
      </button>

      <button nbButton ghost status="info" size="small" (click)="replyQnA()">
        <nb-icon icon="message-square-outline"></nb-icon>

        <div *ngIf="qna.noReply == 0">Trả lời</div>

        <div *ngIf="qna.noReply > 0" style="text-transform: lowercase">
          &nbsp;Xem <span>{{ qna.noReply | number }} </span> câu trả lời
        </div>
      </button>

      <ngx-button-report-spam
        [qna]="qna"
        (onReport)="report($event)"
      ></ngx-button-report-spam>
    </div>

    <nb-card *ngIf="view === 'replies'" class="replies">
      <nb-card-body>
        <ngx-view-replies [qna]="qna" [mode]="mode" (onClose)="closeReplyQnA()">
        </ngx-view-replies>
      </nb-card-body>
    </nb-card>
  </nb-card-footer>
</nb-card>
